import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import styles from "./styles.js";
import useRoom from "../../hooks/useRoom";
import { UserContextForVonage } from "../../context/UserContextForVonage";

import ToolBar from "../ToolBar/index";

import NetworkToast from "../NetworkToast/index";
import useScreenSharing from "../../hooks/useScreenSharing";
import { VonageServices } from "../../../vonageServices";
import UserContext from "src/context/UserContext";
import WaitingToast from "../WaitingToast/index.js";

export default function VideoRoom() {
  const [user, setUser] = useContext(UserContextForVonage);
  const [credentials, setCredentials] = useState(null);
  const [error, setError] = useState(null);
  const { createCall, room, participants, connected, networkStatus, cameraPublishing, localParticipant } = useRoom();
  const { isScreenSharing, startScreenSharing, stopScreenSharing } = useScreenSharing({ room });
  const roomContainer = useRef();
  const classes = styles();
  const { roomName } = useParams();
  const [loggedUser] = useContext(UserContext);
  const [showWaitingForOthersMsg, setShowWaitingForOthersMsg] = useState(true);


  useEffect(() => {
    const disableBackButton = (event) => {
      event.preventDefault();
      window.history.forward();
    };

    // Disable the back button
    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', disableBackButton);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('popstate', disableBackButton);
    };
  }, []);

  useEffect(() => {
    getVonageCredentials();
  }, []);

  const getVonageCredentials = async () => {
    try {
      const sessionData = await VonageServices.createVonageSession(roomName);
      console.log(sessionData);
      if (sessionData) {
        setCredentials({
          apikey: sessionData.apiKey,
          sessionId: sessionData.sessionId,
          token: sessionData?.token,
        });
        await VonageServices.updateSessionIdInMeeting(roomName, sessionData.sessionId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    if(participants.length > 0 ) {
      if(showWaitingForOthersMsg){
        setShowWaitingForOthersMsg(false);
      }
    } else {
      setShowWaitingForOthersMsg(true);
    }
  },[participants])

  useEffect(() => {
    try {
      console.log("VR 02");
      if (credentials) {
        createCall(credentials, roomContainer.current, user.userName, user.videoFilter, {
          ...user.defaultSettings,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [createCall, credentials, user]);

  // Auto update participant status after 30s if room is loaded
  useEffect(() => {
    if (connected && room) {
      const updateParticipantStatus = async () => {
        try {
          // Only call API from therapist role
          // if (loggedUser?.role !== 'therapist') {
          //   console.log('Skipping participant status update - not a therapist');
          //   return;
          // }

          // Method 1: Use room.participants object (more accurate)
          const totalParticipants = room.participants ? Object.keys(room.participants).length : participants.length + 1;

          // Method 2: Alternative - check if localParticipant exists and add accordingly
          // const currentParticipantCount = participants.length + (localParticipant ? 1 : 0);

          console.log(`Updating participant status for room ${roomName}, participantCount: ${totalParticipants}`);
          console.log('Room participants object:', room.participants);
          console.log('Local participant:', localParticipant);

          const response = await VonageServices.updateParticipantStatus(roomName, totalParticipants);
          if (response.success) {
            console.log('Participant status update result:', response.data);
          } else {
            console.error('Failed to update participant status:', response.error);
          }
        } catch (error) {
          console.error('Error updating participant status:', error);
        }
      };

      // Call API after 30 seconds
      const timeoutId = setTimeout(updateParticipantStatus, 30000);

      return () => clearTimeout(timeoutId);
    }
  }, [connected, room, participants.length, roomName, localParticipant, loggedUser]);

  // Real-time participant status update when participants change
  useEffect(() => {
    console.log('🔄 Real-time useEffect triggered:', {
      connected,
      hasRoom: !!room,
      userRole: loggedUser?.role,
      participantsLength: participants.length,
      roomName
    });

    if (connected && room && loggedUser?.role === 'THERAPIST') {
      console.log('✅ Conditions met - executing real-time update');
      
      const updateParticipantStatusRealtime = async () => {
        try {
          const totalParticipants = room.participants ? Object.keys(room.participants).length : participants.length + 1;
          
          console.log('📊 Real-time participant data:', {
            roomParticipants: room.participants,
            roomParticipantsKeys: room.participants ? Object.keys(room.participants) : null,
            participantsArrayLength: participants.length,
            localParticipant: !!localParticipant,
            calculatedTotal: totalParticipants
          });
          
          // Only call API when there are 2 or more participants
          // if (totalParticipants >= 2) {
            console.log(`🚀 Real-time participant update: ${totalParticipants} participants in room ${roomName}`);
            
            const response = await VonageServices.updateParticipantStatus(roomName, totalParticipants);
            if (response.success) {
              console.log('✅ Real-time participant status update result:', response.data);
            } else {
              console.error('❌ Failed to update participant status (real-time):', response.error);
            }
          // }
        } catch (error) {
          console.error('💥 Error updating participant status (real-time):', error);
        }
      };

      // Call immediately when participant count changes
      updateParticipantStatusRealtime();
    } else {
      console.log('❌ Conditions not met for real-time update:', {
        connected,
        hasRoom: !!room,
        isTherapist: loggedUser?.role === 'THERAPIST',
        actualRole: loggedUser?.role
      });
    }
  }, [participants.length, connected, room, roomName, loggedUser]);

  if (error) return <div className={classes.errorContainer}>There was an error fetching the data from the server</div>;

  return (
    <div id="callContainer" className={classes.callContainer}>
      <div id="roomContainer" className={classes.roomContainer} ref={roomContainer}>
        {/* {showWaitingForOthersMsg && <h5 className={classes.waitingText}>Waiting for other party to join...</h5>} */}
        <NetworkToast networkStatus={networkStatus} />
        {showWaitingForOthersMsg && <WaitingToast/>}
        <div id="screenSharingContainer" className={classes.screenSharingContainer}>
          {isScreenSharing && <div className={classes.screenSharingOverlay}>You Are Screensharing</div>}
        </div>
      </div>
      <ToolBar
        room={room}
        participants={participants}
        localParticipant={localParticipant}
        connected={connected}
        cameraPublishing={cameraPublishing}
        isScreenSharing={isScreenSharing}
        startScreenSharing={startScreenSharing}
        stopScreenSharing={stopScreenSharing}
      ></ToolBar>
    </div>
  );
}
